import { SwapHorizOutlined } from '@hangar/react-icons/core/interaction/SwapHorizOutlined';
import { ROUTES } from '../../router/routes';
import type { MenuItem } from './types';

export const baseItems: MenuItem[] = [
  {
    text: 'flightChangesCases.title',
    path: ROUTES.FLIGHT_CHANGE_CASES,
    activePaths: [ROUTES.DASHBOARD],
    icon: SwapHorizOutlined,
  },
];

